import { create } from 'zustand';

/**
 * Shipment store for managing import-related UI state.
 * Simplified after moving to page-based views instead of modals.
 */
export const useImportsStore = create((set, get) => ({
  // Edit mode flag for import edit pages
  importEditMode: false,
  setImportEditMode: (importEditMode) => set({ importEditMode }),

  // Legacy: Keep showImportDetailsModal for backwards compatibility
  // This can be removed once all modal-based code is fully deprecated
  showImportDetailsModal: false,
  setShowImportDetailsModal: (showImportDetailsModal) => set({ showImportDetailsModal }),

  // Upload flow state — hoisted to the store so the page header can trigger
  // the wizard from above the table (CgDataManagementPage primaryAction) while the
  // modal mounts still live inside ImportTable where the submit handlers
  // sit. Skip-guide preference is persisted via localStorage.
  uploadWizardOpen: false,
  setUploadWizardOpen: (uploadWizardOpen) => set({ uploadWizardOpen }),

  uploadGuideOpen: false,
  setUploadGuideOpen: (uploadGuideOpen) => set({ uploadGuideOpen }),

  triggerUploadFlow: () => {
    let hasSkipped = false;
    try {
      hasSkipped = window.localStorage.getItem('shipments-upload-guide-skip') === 'always';
    } catch (_err) {
      // Ignore storage failures (private mode etc.).
    }
    if (hasSkipped) {
      set({ uploadWizardOpen: true });
    } else {
      set({ uploadGuideOpen: true });
    }
  },

  // See suppliersStore.closeAllModals — same module-global lifetime problem,
  // same contract: navigation shuts every modal this store gates. Edit mode
  // and the draft shipment are not modals and survive on purpose.
  closeAllModals: () =>
    set({
      showImportDetailsModal: false,
      uploadWizardOpen: false,
      uploadGuideOpen: false,
    }),

  // Draft shipment for form persistence (useful for create page)
  draftShipment: null,
  setDraftShipment: (draftShipment) => set({ draftShipment }),
  clearDraftShipment: () => set({ draftShipment: null }),

  // Draft content operations (for managing content in create forms)
  updateDraftShipmentContent: (content, index) => {
    const draft = get().draftShipment;
    if (!draft) return;

    const updatedContents = [...(draft.shipmentContents || [])];
    if (index !== undefined && index !== null) {
      updatedContents[index] = content;
    } else {
      updatedContents.push(content);
    }

    set({
      draftShipment: {
        ...draft,
        shipmentContents: updatedContents,
      },
    });
  },
  removeDraftShipmentContent: (index) => {
    const draft = get().draftShipment;
    if (!draft) return;

    const updatedContents = draft.shipmentContents.filter((_, i) => i !== index);
    set({
      draftShipment: {
        ...draft,
        shipmentContents: updatedContents,
      },
    });
  },
}));
